import Vue from 'vue'
import VueScreen from 'vue-screen'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import VueGtag from 'vue-gtag'
import { notify } from '@/_helpers/notify'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// this.$notify.*: every toast in the app goes through here.
Vue.use(notify)

// Composition API
Vue.use(VueCompositionAPI)

// Bootstrap
Vue.use(VueScreen, 'bootstrap')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: 'G-8MPKGWD15Z',
  },
}, router)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
